/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { SystemEventName } from '../enums/system-event-name';
import { SystemEventStatus } from '../enums/system-event-status';
import { SystemEventType } from '../enums/system-event-type';
export class SystemEventEntity extends Entity {
  createdAt: string | null = null;
  id: string = '';
  name: SystemEventName = null as unknown as never;
  status: SystemEventStatus | null = null;
  type: SystemEventType = null as unknown as never;
  updatedAt: string | null = null;
  value: Record<string, unknown> | null = null;
  static override key = 'SystemEvent';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'SystemEvent' in input
    ) {
      const { SystemEvent: wrapped, ...rest } = input as {
        SystemEvent: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}